import { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../utils/helpers';
import { feedingRequestsApi } from '../utils/api';

const CatCard = ({ cat, onRequestSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  
  // Default image if no cat photo is available
  const defaultImage = '/cat-placeholder.png';
  
  // Get the main photo URL from catPhotos array if available
  const photoUrl = cat.catPhotos && cat.catPhotos.length > 0 
    ? cat.catPhotos[0].path 
    : cat.mainPhoto || defaultImage;
  
  // Format the last feeding date or show "Not yet fed" if it's null
  const formattedLastFed = cat.lastFed 
    ? formatDate(cat.lastFed, { hour: undefined, minute: undefined }) 
    : 'Not yet fed';
  
  // Handle feed request click
  const handleFeedRequest = async () => {
    if (loading || requestSent) return;
    
    try {
      setLoading(true);
      await feedingRequestsApi.createFeedingRequest(cat.id);
      setRequestSent(true);
      
      if (onRequestSuccess) {
        onRequestSuccess(cat.id);
      }
    } catch (error) {
      console.error('Error sending feed request:', error);
      // You could also show a toast notification here
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="cat-card">
      <div className="cat-card-image">
        <img 
          src={photoUrl} 
          alt={cat.name} 
          onError={(e) => {
            e.target.src = defaultImage;
          }}
        />
        <div className="cat-gender">{cat.gender === 'M' ? '♂️' : '♀️'}</div>
      </div>
      
      <div className="cat-card-content">
        <h3 className="cat-name">
          <Link to={`/dashboard/cats/${cat.id}`}>{cat.name}</Link>
        </h3>
        
        <div className="cat-info">
          <div className="cat-info-item">
            <span className="cat-info-label">Feeder:</span>
            <span className="cat-info-value">{cat.feederName}</span>
          </div>
          
          <div className="cat-info-item">
            <span className="cat-info-label">Last Fed:</span>
            <span className="cat-info-value">{formattedLastFed}</span>
          </div>
          
          <div className="cat-info-item">
            <span className="cat-info-label">Pending Requests:</span>
            <span className="cat-info-value">{cat.pendingRequests || 0}</span>
          </div>
        </div>
        
        <p className="cat-description">
          {cat.description?.length > 100 
            ? `${cat.description.substring(0, 100)}...` 
            : cat.description}
        </p>
      </div>
      
      <div className="cat-card-actions">
        <Link 
          to={`/dashboard/cats/${cat.id}`} 
          className="button secondary view-button"
        >
          View Details
        </Link>
        
        <button 
          className={`button ${requestSent ? 'success' : ''}`}
          onClick={handleFeedRequest}
          disabled={loading || requestSent}
        >
          {loading ? 'Requesting...' : requestSent ? 'Requested ✓' : 'Request Feed'}
        </button>
      </div>
    </div>
  );
};

export default CatCard; 